import client from './client';

/**
 * Filter out undefined and null values from an object
 */
function cleanParams(params) {
  return Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null)
  );
}

export async function listSchedules({ companyId, siteId } = {}) {
  const params = cleanParams({ companyId, siteId });
  const { data } = await client.get('/api/ta/schedules', { params });
  return data;
}

export async function createSchedule(data) {
  const response = await client.post('/api/ta/schedules', data);
  return response.data;
}

export async function updateSchedule(id, data) {
  const response = await client.put(`/api/ta/schedules/${id}`, data);
  return response.data;
}

export async function deleteSchedule(id) {
  const { data } = await client.delete(`/api/ta/schedules/${id}`);
  return data;
}

export async function listSessions(params = {}) {
  const cleanedParams = cleanParams(params);
  const { data } = await client.get('/api/ta/sessions', { params: cleanedParams });
  return data;
}

export async function getOverview(companyId) {
  const params = cleanParams({ companyId });
  const { data } = await client.get('/api/ta/overview', { params });
  return data;
}

export async function listOverrides({ companyId, status } = {}) {
  const params = cleanParams({ companyId, status });
  const { data } = await client.get('/api/ta/overrides', { params });
  return data;
}

export async function reviewOverride(id, { status, reviewReason }) {
  const { data } = await client.patch(`/api/ta/overrides/${id}/review`, { status, reviewReason });
  return data;
}

export async function reviewSelfie(sessionId, note) {
  const { data } = await client.patch(`/api/ta/sessions/${sessionId}/selfie-review`, { note });
  return data;
}
